import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import { pdfjs } from 'react-pdf';

class GetPdfPages {
  execute(file) {
    return __awaiter(this, void 0, void 0, function* () {
      pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
      try {
        const document = yield pdfjs.getDocument(URL.createObjectURL(file)).promise;
        return document.numPages;
      } catch (error) {
        return 0;
      }
    });
  }
}

export { GetPdfPages };
